import type { SearchResultItem } from 'owa-timestream-search-orchestration';
import type CalendarItem from 'owa-service/lib/contract/CalendarItem';
import { userDate, compare, startOfMonth, OwaDate } from 'owa-datetime';

/**
 * Callback function to return the item headers to inject into the search results
 */
export default function getSearchResultHeaders(items: SearchResultItem[]): SearchResultItem[] {
    // calendar item headers are just month header labels
    // sort items by start time, then iterate over them to see which months between first and last item need a header, then return those

    const startDates = items.map(item => userDate((item.data as CalendarItem).Start as string));

    const headerMonths: OwaDate[] = [];
    let mostRecentDate: OwaDate | null = null;
    startDates
        .sort((date1, date2) => {
            return compare(date1, date2);
        })
        .forEach(date => {
            const month = startOfMonth(date);
            if (!mostRecentDate || compare(month, mostRecentDate!) > 0) {
                mostRecentDate = month;
                headerMonths.push(month);
            }
        });

    return headerMonths.map(month => {
        return {
            type: 'calendarItem',
            id: 'calendarItem_monthHeader_' + month,
            immutableId: '',
            data: {
                Start: month,
            },
            matchingTerms: [],
        } as SearchResultItem;
    });
}
